function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".erbjudanden_svg__cls-1{fill:none;stroke:#000;stroke-linejoin:round;stroke-width:.25px}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "erbjudanden_svg__cls-1",
  d: "M5.85 11.553L4.133 4.606M2.998.147l1.135 4.459L5.85.146M.147 4.606H5.85M5.85 11.553l1.717-6.947"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "erbjudanden_svg__cls-1",
  d: "M5.85.147h2.852l2.851 4.459-5.703 6.947L.147 4.606 2.998.146H5.85"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "erbjudanden_svg__cls-1",
  d: "M8.702.147L7.567 4.606 5.85.146M11.553 4.606H5.85"
});

function SvgErbjudanden(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "erbjudanden_svg__Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.7 11.7"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgErbjudanden;